module.exports = {
          srcSet: __webpack_public_path__ + "13d5931b.jpg"+" 700w"+","+__webpack_public_path__ + "43df3d58.jpg"+" 1400w"+","+__webpack_public_path__ + "66ed47d9.jpg"+" 2000w",
          images:[ {path: __webpack_public_path__ + "13d5931b.jpg",width: 700,height: 394},{path: __webpack_public_path__ + "43df3d58.jpg",width: 1400,height: 788},{path: __webpack_public_path__ + "66ed47d9.jpg",width: 2000,height: 1126}],
          src: __webpack_public_path__ + "13d5931b.jpg",
          toString:function(){return __webpack_public_path__ + "13d5931b.jpg"},
          
          width: 700,
          height: 394
        }